import FastJoinAudience from 'features/join/fast-join/FastJoinAudience';
import Intro from 'features/join/shared/Intro';
import PendingMediaNotice from 'features/join/shared/PendingMediaNotice';
import { BroadcastMediaStatus } from 'utils/broadcast-setup';

type FastJoinPublisherLayoutProps = {
  status: BroadcastMediaStatus;
  onReload: () => void;
  onJoinWithoutMedia: () => void;
};

const FastJoinPublisherLayout = ({
  status,
  onReload,
  onJoinWithoutMedia,
}: FastJoinPublisherLayoutProps) => {
  if (status === 'failure' || status === 'denied') {
    return <FastJoinAudience />;
  }

  if (status === 'stalled') {
    return <PendingMediaNotice onReload={onReload} onJoinWithoutMedia={onJoinWithoutMedia} />;
  }

  return <Intro />;
};

export default FastJoinPublisherLayout;
